export function compare(text) {
    return `


    <div class=WordSection1>

    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>1&nbsp;&nbsp;&nbsp;Making comparisons using comparative adjectives</span></u></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:white'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;<b>What is a comparative adjective?</b><br>
    A&nbsp;<b>comparative adjective</b>&nbsp;in English is one with -<i>er</i>&nbsp;on
    the end of it or&nbsp;<i>more</i>&nbsp;or&nbsp;<i>less</i>&nbsp;in front of it,
    that is used to compare people or things, for example,&nbsp;<i>cleverer</i>,&nbsp;<i>less
    important</i>,&nbsp;<i>more beautiful</i>.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>In Spanish, to say something is&nbsp;<i>cheaper</i>,&nbsp;<i>more
    expensive</i>&nbsp;and so on, you use&nbsp;<b>más</b>&nbsp;(meaning&nbsp;<i>more</i>)
    before the adjective.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Esta
      bicicleta es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
      "inherit",serif'>&nbsp;<b>más barata.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This
      bicycle is cheaper.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>La
      verde es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>más
      cara.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>The green
      one is more expensive.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To say something is&nbsp;<i>less expensive</i>,&nbsp;<i>less
    beautiful</i>&nbsp;and so on, you use&nbsp;<b>menos</b>&nbsp;(meaning&nbsp;<i>less</i>)
    before the adjective.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>La
      verde es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>menos
      cara.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>The green
      one is less expensive.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To introduce the person or thing you are making the comparison
    with, use&nbsp;<b>que</b>&nbsp;(meaning&nbsp;<i>than</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Es</span></b><span
      lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>más</b>&nbsp;<b>alto</b>&nbsp;<b>que</b>&nbsp;<b>yo.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>He’s
      taller than me.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>La
      otra bicicleta es</span></b><span lang=ES-MX style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b>más</b>&nbsp;<b>cara</b>&nbsp;<b>que</b>&nbsp;<b>esta.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>The other
      bicycle is more expensive than this one.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Esta
      bicicleta es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
      "inherit",serif'>&nbsp;<b>menos</b>&nbsp;<b>cara</b>&nbsp;<b>que</b>&nbsp;<b>la
      otra.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This
      bicycle is less expensive than the other one.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>Grammar Extra!When&nbsp;<i>than</i>&nbsp;in
    English is followed by a verbal construction, use&nbsp;<b>de lo que</b>&nbsp;rather
    than&nbsp;<b>que</b>&nbsp;alone.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Está</span></b><span
      lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>más</b>&nbsp;<b>cansada</b>&nbsp;<b>de
      lo que</b>&nbsp;<b>parece.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She is
      more tired than she seems.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>2&nbsp;&nbsp;&nbsp;Making comparisons using superlative adjectives</span></u></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:white'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;<b>What is a superlative adjective?</b><br>
    A&nbsp;<b>superlative adjective</b>&nbsp;in English is one with&nbsp;<i>-est</i>&nbsp;on
    the end of it or&nbsp;<i>most</i>&nbsp;or&nbsp;<i>least</i>&nbsp;in front of
    it, that is used to compare people or things, for example,&nbsp;<i>thinnest</i>,&nbsp;<i>most
    beautiful</i>,&nbsp;<i>least interesting</i>.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>In Spanish, to say something is&nbsp;<i>the cheapest</i>,&nbsp;<i>th</i>e&nbsp;<i>most
    expensive</i>&nbsp;and so on, you use&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las</b>&nbsp;(+
    noun) +&nbsp;<b>más</b>&nbsp;+ adjective.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>caballo</b>&nbsp;<b>más
      viejo</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the oldest
      horse</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>la</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>casa</b>&nbsp;<b>más
      peque&ntilde;a</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the
      smallest house</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>los</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>hoteles</b>&nbsp;<b>más
      baratos</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the
      cheapest hotels</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>las</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>manzanas</b>&nbsp;<b>más
      caras</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the most
      expensive apples</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Quién
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>el
      más alto?</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Who’s the
      tallest?</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To say something is&nbsp;<i>the least expensive</i>,&nbsp;<i>the
    least intelligent</i>&nbsp;and so on, you use&nbsp;<b>el</b>/<b>la</b>/<b>los</b>/<b>las</b>&nbsp;(+
    noun) +&nbsp;<b>menos</b>&nbsp;+ adjective.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>hombre</b>&nbsp;<b>menos
      simpático</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the least
      likeable man</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>la</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>ni&ntilde;a</b>&nbsp;<b>menos
      habladora</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the least
      talkative girl</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>los</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>cuadros</b>&nbsp;<b>menos
      bonitos</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the least
      attractive paintings</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>las</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>empleadas</b>&nbsp;<b>menos
      trabajadoras</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the least
      hardworking (female) employees</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&iquest;Quién
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>el
      menos trabajador?</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Who’s the
      least hardworking?</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>TipIn phrases
    like&nbsp;<i>the cleverest girl in the school</i>&nbsp;and&nbsp;<i>the tallest
    man in the world</i>, you use&nbsp;<b>de</b>&nbsp;to translate&nbsp;<i>in</i>.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>el
      hombre más alto</span></b><span lang=ES-MX style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b>del&nbsp;mundo</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the
      tallest man&nbsp;in&nbsp;the world</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>3&nbsp;&nbsp;&nbsp;Irregular comparatives and superlatives</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>Just as English has some irregular comparative and superlative
    forms –&nbsp;<i>better</i>&nbsp;instead of ‘<i>more good’</i>, and&nbsp;<i>worst</i>&nbsp;instead
    of ‘<i>most bad’</i>&nbsp;– Spanish also has a few irregular forms.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Adjective</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Meaning</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Comparative</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Meaning</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Superlative</span></b></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Meaning</span></b></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>bueno</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>good</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>mejor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>better</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el
      mejor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the best</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>malo</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>bad</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>peor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>worse</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el peor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the worst</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>grande</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>big</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>mayor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>older</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el
      mayor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the oldest</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>peque&ntilde;o</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>small</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>menor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>younger</span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>el
      menor</span></b></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the
      youngest</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>&nbsp;</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Este
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>mejor</b>&nbsp;<b>que
      el otro.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This one
      is better than the other one.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Es</span></b><span
      lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>el
      mejor</b>&nbsp;<b>de todos.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>It’s the
      best of the lot.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Hoy me
      siento</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>peor.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I feel
      worse today.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>la
      peor</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>alumna
      de la clase</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the worst
      student in the class</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>Note that&nbsp;<b>mejor</b>,&nbsp;<b>peor</b>,&nbsp;<b>mayor</b>&nbsp;and&nbsp;<b>menor</b>&nbsp;don’t
    change their endings in the feminine. In the plural, they become&nbsp;<b>mejores</b>,&nbsp;<b>peores</b>,&nbsp;<b>mayores</b>&nbsp;and&nbsp;<b>menores</b>.
    Don’t forget to use&nbsp;<b>el</b>,&nbsp;<b>la</b>,&nbsp;<b>los</b>&nbsp;or&nbsp;<b>las</b>&nbsp;as
    appropriate, depending on whether the person or thing described is masculine or
    feminine, singular or plural.</span></p>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>Tip<b>más
    grande</b>&nbsp;and&nbsp;<b>más peque&ntilde;o</b>&nbsp;are used mainly to talk
    about the actual size of something.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Este
      plato es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>más
      grande</b>&nbsp;<b>que aquel.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This plate
      is bigger than that one.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Mi
      casa es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>más
      peque&ntilde;a</b>&nbsp;<b>que la tuya.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>My house
      is smaller than yours.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>mayor</span></b><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>&nbsp;and&nbsp;<b>menor</b>&nbsp;are
    used mainly to talk about age.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>mis
      hermanos</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>mayores</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>my older
      brothers</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>la hija</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>menor</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>the
      youngest daughter</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'><span style='text-decoration:none'>&nbsp;</span></span></u></b></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    24.0pt;background:white'><b><u><span style='font-size:16.0pt;font-family:"inherit",serif;
    color:black'>4&nbsp;&nbsp;&nbsp;Other ways of making comparisons</span></u></b></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To say&nbsp;<i>as … as</i>&nbsp;(for example,&nbsp;<i>as pretty
    as, not as pretty as</i>) you use&nbsp;<b>tan … como</b>&nbsp;in Spanish.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Pedro
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>tan</b>&nbsp;<b>alto</b>&nbsp;<b>como</b>&nbsp;<b>Miguel.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Pedro is
      as tall as Miguel.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>No
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>tan</b>&nbsp;<b>guapa</b>&nbsp;<b>como</b>&nbsp;<b>su
      madre.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She isn’t
      as pretty as her mother.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>No
      es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>tan</b>&nbsp;<b>grande</b>&nbsp;<b>como</b>&nbsp;<b>yo
      creía.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>It isn’t
      as big as I thought.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>Grammar
    Extra!You use&nbsp;<b>tanto</b>&nbsp;with a noun rather than&nbsp;<b>tan</b>&nbsp;with
    an adjective in some expressions. This is because in Spanish you would use a
    noun where in English we would use an adjective.</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Pablo
      tiene</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>tanto</b>&nbsp;<b>miedo</b>&nbsp;<b>como</b>&nbsp;<b>yo.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>Pablo is
      as frightened as I am.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Yo
      no tengo</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>tanta</b>&nbsp;<b>hambre</b>&nbsp;<b>como</b>&nbsp;<b>tú.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>I’m not as
      hungry as you are.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:white'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>To make an adjective stronger, you can use&nbsp;<b>muy</b>&nbsp;(meaning&nbsp;<i>very</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Este
      libro es</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>muy</b>&nbsp;<b>interesante.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>This book
      is very interesting.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>Grammar
    Extra!For even more emphasis, you can add&nbsp;<b>-ísimo</b>&nbsp;(meaning&nbsp;<i>really,
    extremely</i>) to the end of an adjective. Take off the final vowel if the
    adjective already ends in one. For example,&nbsp;<b>delgado</b>&nbsp;(meaning&nbsp;<i>thin</i>)
    becomes&nbsp;<b>delgadísimo</b>&nbsp;(meaning&nbsp;<i>really thin</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif'>Se
      ha comprado un coche</span></b><span lang=ES-MX style='font-size:12.0pt;
      font-family:"inherit",serif'>&nbsp;<b>carísimo.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>He’s
      bought himself a really expensive car.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Está</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>delgadísima.</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>She’s
      looking really thin.</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>If you
    add&nbsp;<b>-ísimo</b>, you need to take off any other accent. For
    example,&nbsp;<b>fácil</b>&nbsp;(meaning&nbsp;<i>easy</i>) becomes&nbsp;<b>facilísimo</b>&nbsp;(meaning&nbsp;<i>extremely
    easy</i>) and&nbsp;<b>rápido</b>&nbsp;(meaning&nbsp;<i>fast</i>) becomes&nbsp;<b>rapidísimo</b>&nbsp;(meaning&nbsp;<i>extremely
    fast</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Es</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>facilísimo</b>&nbsp;<b>de
      hacer.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>It’s
      really easy to make.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>un
      coche</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>rapidísimo</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>an
      extremely fast car</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='line-height:normal;background:white'><span
    style='font-size:13.5pt;font-family:"inherit",serif;color:black'>When the
    adjective ends in&nbsp;<b>-co</b>,&nbsp;<b>-go</b>&nbsp;or&nbsp;<b>-z</b>,
    spelling changes are required to keep the same sound. For example,&nbsp;<b>rico</b>&nbsp;(meaning&nbsp;<i>rich</i>)
    becomes&nbsp;<b>riquísimo</b>&nbsp;(meaning&nbsp;<i>extremely rich</i>)
    and&nbsp;<b>feroz</b>&nbsp;(meaning&nbsp;<i>fierce</i>) becomes&nbsp;<b>ferocísimo</b>&nbsp;(meaning&nbsp;<i>extremely
    fierce</i>).</span></p>
    
    <table class=MsoNormalTable border=1 cellspacing=0 cellpadding=0
     style='border-collapse:collapse;border:none'>
     <tr>
      <td valign=top style='border:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>Se hizo</span></b><span
      style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>riquísimo.</b></span></p>
      </td>
      <td valign=top style='border:solid black 1.0pt;border-left:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>He became
      extremely rich.</span></p>
      </td>
     </tr>
     <tr>
      <td valign=top style='border:solid black 1.0pt;border-top:none;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><b><span style='font-size:12.0pt;font-family:"inherit",serif'>un
      tigre</span></b><span style='font-size:12.0pt;font-family:"inherit",serif'>&nbsp;<b>ferocísimo</b></span></p>
      </td>
      <td valign=top style='border-top:none;border-left:none;border-bottom:solid black 1.0pt;
      border-right:solid black 1.0pt;padding:6.0pt 16.8pt 6.0pt 16.8pt'>
      <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
      normal'><span style='font-size:12.0pt;font-family:"inherit",serif'>an
      extremely fierce tiger</span></p>
      </td>
     </tr>
    </table>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:white'><span style='font-size:10.0pt;font-family:Symbol;color:black'>·<span
    style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>For more information on</span></i><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>&nbsp;<b><i>Spelling</i></b>&nbsp;<i>and</i>&nbsp;<b><i>Stress</i></b><i>,
    see&nbsp;</i></span><i><u><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:blue'><a
    href="https://grammar.collinsdictionary.com/spanish-easy-learning/spelling"
    title="Explanation of Spelling"><span style='color:blue'>Spelling</span></a></span></u></i><i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>&nbsp;and&nbsp;</span></i><i><u><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:blue'><a
    href="https://grammar.collinsdictionary.com/spanish-easy-learning/stress"
    title="Explanation of Stress"><span style='color:blue'>Stress</span></a></span></u></i><i><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>.</span></i></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>&nbsp;</span></p>
    
    <p class=MsoNormal style='margin-bottom:0cm;margin-bottom:.0001pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:13.5pt;font-family:"inherit",serif;
    color:black'>Key points</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>Comparative adjectives in Spanish are formed by:</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>más</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;+ adjective +&nbsp;<b>que</b></span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>menos</span></b><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>&nbsp;+ adjective +&nbsp;<b>que</b></span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>Superlative adjectives in Spanish are formed by:</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:#E1E4EE'><span lang=ES-MX style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>el</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
    "inherit",serif;color:black'>/<b>la</b>/<b>los</b>/<b>las</b>&nbsp;+&nbsp;<b>más</b>&nbsp;+
    adjective</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:9.6pt;margin-bottom:.0001pt;text-indent:-3.75pt;line-height:normal;
    background:#E1E4EE'><span lang=ES-MX style='font-size:10.0pt;font-family:Symbol;
    color:black'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><b><span lang=ES-MX style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>el</span></b><span lang=ES-MX style='font-size:12.0pt;font-family:
    "inherit",serif;color:black'>/<b>la</b>/<b>los</b>/<b>las</b>&nbsp;+&nbsp;<b>menos</b>&nbsp;+
    adjective</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>There are a few irregular comparative and superlative forms in
    Spanish.</span></p>
    
    <p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:0cm;
    margin-left:18.0pt;margin-bottom:.0001pt;text-indent:-18.0pt;line-height:normal;
    background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>You can use&nbsp;</span><b><span style='font-size:12.0pt;
    font-family:"inherit",serif;color:black'>tan ... como</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>&nbsp;to
    say&nbsp;</span><i><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:black'>as ... as</span></i><span style='font-size:12.0pt;font-family:
    "inherit",serif;color:#B71533'>.</span></p>
    
    <p class=MsoNormal style='margin-left:18.0pt;text-indent:-18.0pt;line-height:
    normal;background:#E1E4EE'><span style='font-size:10.0pt;font-family:Symbol;
    color:#B71533'>·<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span></span><span style='font-size:12.0pt;font-family:"inherit",serif;
    color:#B71533'>To make an adjective stronger, use&nbsp;</span><b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:black'>muy</span></b><span
    style='font-size:12.0pt;font-family:"inherit",serif;color:#B71533'>.</span></p>
    
    <p class=MsoNormal>&nbsp;</p>
    
    </div>
    





    `;
}
